import React, { Component } from 'react'
import styled from 'styled-components'
import { Link } from "gatsby"
import Img from "gatsby-image"

const StoryPreviewSquare = styled.div`
  width: 100%;
  border-radius: 10px;
  background: white;
  min-height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  ${props => props.overspill ?  'padding-left: 40px; margin-left: -30px;' : ''}
  img {
    border-radius: 10px 10px 0 0;
    width: 100%;
    object-fit: cover;
    margin-bottom: 0;
  };

  > .story-info {
    padding: 20px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    > p {
      font-size: 0.8em;
      flex-grow: 1;
    }
  }
`

class StoryPreviewSquareElement extends Component {
  render() {
    const storyData = this.props.storyData.node;

    return(
      <StoryPreviewSquare>
        <Link style={{marginBottom: '-4px'}} to={storyData.fields.slug}>
          <Img style={{width: '100%'}} fixed={storyData.frontmatter.image.childImageSharp.fixed} />
        </Link>
        <div className="story-info">
          <h5>{storyData.frontmatter.title}</h5>
          <p>{storyData.excerpt}</p>
          <div style={{justifyContent: 'flex-end', display: 'flex'}}><Link className='preview-link' to={storyData.fields.slug}>Read Story</Link></div>
        </div>
      </StoryPreviewSquare>
    )
  }
}

export default StoryPreviewSquareElement